import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { PackageLinksData, PackagesEndpointMethod } from '../types';
import { Package } from '../types/packages-grid-package';
import { DeleteSelectedResponse } from '../types/packages-grid-responses';

export class PackagesBaseDataProvider extends BaseWebComponentDataProvider {
  private dataProviderType = DataProviderType.CORE;
  private endpoint = 'Packages';

  public async deleteSelectedPackages(payload: { records: Array<Package> }): Promise<DeleteSelectedResponse> {
    return await ConsoleRequest.createRequest<DeleteSelectedResponse>({
      dataProviderType: this.dataProviderType,
      payload,
      endpoint: this.endpoint,
      method: PackagesEndpointMethod.REMOVE_RECORDS,
    });
  }

  public async getPackageLinks(packageId: string): Promise<PackageLinksData> {
    return await ConsoleRequest.createRequest<PackageLinksData>({
      dataProviderType: this.dataProviderType,
      payload: { packageId: packageId },
      endpoint: this.endpoint,
      method: PackagesEndpointMethod.GET_PACKAGE_LINKS,
    });
  }

  public async getDataForView(): Promise<{}> {
    return {};
  }
}
